import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CustomerRoutes } from './routes/customer/customerRoutes';

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<CustomerRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesApp;
